import { render, staticRenderFns } from "./StatCards.vue?vue&type=template&id=47fb4d9d&scoped=true"
import script from "./StatCards.vue?vue&type=script&lang=js"
export * from "./StatCards.vue?vue&type=script&lang=js"
import style0 from "./StatCards.vue?vue&type=style&index=0&id=47fb4d9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb4d9d",
  null
  
)

export default component.exports